import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'
import Dashboard from '@/views/dashboard/index'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    children: [{
      path: '',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '啤酒机后台管理系统' }
    }
    ]
  },
  {
    path: '',
    component: Layout,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '我的主页', icon: 'international', affix: true }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  }
]
export default new Router({
  routes: constantRoutes
})

export const asyncRoutes = [
  {
    path: '/devices',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'Devices',
        component: () => import('@/views/Devices'),
        meta: { title: '设备管理', icon: 'documentation', affix: true }
      }
    ]
  },
  {
    path: '/disinfect',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'Disinfect',
        component: () => import('@/views/Disinfect'),
        meta: { title: '消毒参数管理', icon: 'excel', affix: true }
      }
    ]
  },
  {
    path: '/caft',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'Caft',
        component: () => import('@/views/Craft'),
        meta: { title: '工艺管理', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/rom',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'Rom',
        component: () => import('@/views/Rom'),
        meta: { title: 'ROM管理', icon: 'list', affix: true }
      }
    ]
  },
  {
    path: '/alarm',
    component: Layout,
    name: 'Alarmmain',
    redirect: 'noredirect',
    meta: { title: '报警管理', icon: 'message', affix: true },
    children: [
      {
        path: 'index',
        name: 'Alarm',
        component: () => import('@/views/Alarm/alarm'),
        meta: { title: '报警信息' }
      },
      {
        path: '/alarm/set',
        name: 'Alarmset',
        component: () => import('@/views/Alarm/alarmset'),
        meta: { title: '报警状态设置' }
      }
    ]
  },
  {
    path: '/notice',
    component: Layout,
    name: 'Noticemain',
    redirect: 'noredirect',
    meta: { title: '提示管理', icon: 'user', affix: true },
    children: [
      {
        path: 'index',
        name: 'Notice',
        component: () => import('@/views/Notice/notice'),
        meta: { title: '用户提示', affix: true }
      },
      {
        path: 'set',
        name: 'Noticeset',
        component: () => import('@/views/Notice/noticeset'),
        meta: { title: '提示设置', affix: true }
      }
    ]
  },
  {
    path: '/state',
    component: Layout,
    name: 'Statemain',
    redirect: 'noredirect',
    meta: { title: '工作管理', icon: 'clipboard', affix: true },
    children: [
      {
        path: 'index',
        name: 'State',
        component: () => import('@/views/State/state'),
        meta: { title: '工作状态信息', affix: true }
      },
      {
        path: 'set',
        name: 'Stateset',
        component: () => import('@/views/State/stateset'),
        meta: { title: '工作状态设置', affix: true }
      }
    ]
  },
  {
    path: '/log',
    component: Layout,
    name: 'Logmain',
    redirect: 'noredirect',
    meta: { title: '日志管理', icon: 'edit', affix: true },
    children: [
      {
        path: 'index',
        name: 'Log',
        component: () => import('@/views/Log/log'),
        meta: { title: '日志', affix: true }
      },
      {
        path: 'set',
        name: 'Logset',
        component: () => import('@/views/Log/logstate'),
        meta: { title: '日志状态设置', affix: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js